export const openHouseRegistration = {
  meta: {
    title: "Inscripción Jornada de Puertas Abiertas | Gándara International School",
    description: "Reserva tu plaza en nuestra próxima jornada de puertas abiertas. Descubre nuestra metodología Montessori, instalaciones y equipo docente.",
  },
  hero: {
    title: "Jornada de Puertas Abiertas",
    subtitle: "Ven a conocer nuestra escuela Montessori e inscríbete en nuestra próxima jornada",
    // ── Cambiar esta fecha para futuras jornadas ──
    date: "28 de febrero de 2026",
    badge: "Plazas limitadas",
  },
  formTitle: "Reserva tu plaza",
  formSubtitle: "Completa tus datos y te confirmaremos tu asistencia",
  highlights: {
    title: "¿Qué descubrirás?",
    items: [
      "Nuestra metodología Montessori en acción",
      "Las instalaciones y espacios naturales",
      "El equipo docente y su enfoque pedagógico",
      "El modelo trilingüe (español, inglés, gallego)",
    ],
  },
};
